// removed by extract-text-webpack-plugin
module.exports = {"matchup":"matchupCell__matchup--2LcjJ"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/DataTable/StatCells/matchupCell.css
// module id = Gh/6
// module chunks = 47